import Picture from "@/components/ui/picture";

const portraitWebp = "/assets/eliza-portrait.webp";
const portraitJpg = "/assets/eliza-portrait.jpg";

const Hero = () => {
  return (
    <header className="relative overflow-hidden bg-muted">
      <div className="container grid gap-12 px-6 py-16 sm:py-24 md:grid-cols-2 md:items-center md:gap-16 md:py-28">
        <div className="order-2 md:order-1">
          <p className="mb-5 font-script text-2xl text-primary">A letter from Eliza</p>
          <h1 className="font-serif text-4xl leading-tight text-foreground sm:text-5xl md:text-6xl">
            At 45, I almost gave up on losing this stubborn belly fat…
          </h1>
          <p className="mt-10 text-xl text-foreground/80">
            I tried everything… and nothing worked.
          </p>
          <p className="mt-6 italic text-foreground/75">
            If you're over 45 and feel like your body changed overnight… I understand.
          </p>
          <p className="mt-2 italic text-foreground/80">
            I wish someone had explained it to me this way back then.
          </p>
          <div className="mt-8 space-y-4 text-foreground/85">
            <p>
              For a long time, I felt frustrated with my own reflection. The clothes I loved
              stopped fitting. My energy quietly slipped away.
            </p>
            <p>
              Hormones, stress, sleep — everything seemed to be shifting at once, and nothing I
              used to do was helping anymore.
            </p>
          </div>
          <div className="mt-10 rounded-2xl bg-background/70 px-6 py-6 ring-1 ring-border/60">
            <p className="font-serif text-lg italic text-foreground/85">
              If this feels like you… you don't have to figure it out alone.
            </p>
            <a
              href="#guide"
              className="mt-4 inline-flex items-center justify-center rounded-full bg-primary px-6 py-3 text-base font-medium text-primary-foreground transition-opacity hover:opacity-90"
            >
              I'd like to start gently
            </a>
            <a
              href="#join"
              className="mt-3 block text-sm text-primary underline-offset-4 hover:underline"
            >
              Or read my story first ↓
            </a>
          </div>
        </div>
        <div className="order-1 md:order-2">
          <div className="relative mx-auto aspect-[4/5] w-full max-w-md overflow-hidden rounded-[2rem] bg-secondary shadow-sm">
            <Picture
              webp={portraitWebp}
              fallback={portraitJpg}
              alt="Portrait of Eliza Reed, wellness writer for women over 45"
              width={1024}
              height={1280}
              loading="eager"
              fetchPriority="high"
              decoding="async"
              className="h-full w-full object-cover"
            />

          </div>
        </div>
      </div>
    </header>
  );
};

export default Hero;
